import React from 'react';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import TaskCardItems from './TaskCardItems';

const TaskCards = ({
  allowDatasetLink,
  allowRequestLink,
  canEdit,
  category,
  email,
  handleScroll,
  items,
  itemsPerRow,
  readErrors,
  readStatus,
}) => (
  <InfiniteScrollCards
    className="aridhia-task-cards"
    entity="tasks"
    handleScroll={handleScroll}
    icon="tasks"
    items={items}
    itemsPerRow={itemsPerRow}
    loading
    readErrors={readErrors}
    readStatus={[readStatus]}
  >
    <TaskCardItems
      allowDatasetLink={allowDatasetLink}
      allowRequestLink={allowRequestLink}
      canEdit={canEdit}
      category={category}
      email={email}
      items={items}
    />
  </InfiniteScrollCards>
);

export default TaskCards;
